const TRACKING_SUBSCRIPTION_ID = "admin-map";
const TRACKING_SOCKET_PATH = "/api/v1/driver_actives/ws";

function getTrackingSocketUrl() {
  const apiUrl = process.env.REACT_APP_API_NOTIFICATION_URL;
  if (!apiUrl) throw new Error("No está configurada la URL del backend.");

  const socketUrl = new URL(TRACKING_SOCKET_PATH, apiUrl);
  socketUrl.protocol = socketUrl.protocol === "https:" ? "wss:" : "ws:";
  return socketUrl.toString();
}

export function connectAdminDriversSocket({ token, onEvent, onStatus, onError }) {
  let socket;
  let reconnectTimer;
  let disposed = false;
  let stopRetrying = false;
  let reconnectAttempt = 0;

  const scheduleReconnect = () => {
    if (disposed || stopRetrying) return;
    const delay = Math.min(1000 * (2 ** reconnectAttempt), 15000);
    reconnectAttempt += 1;
    onStatus("reconnecting");
    reconnectTimer = window.setTimeout(connect, delay);
  };

  function connect() {
    if (disposed) return;

    onStatus(reconnectAttempt > 0 ? "reconnecting" : "connecting");
    try {
      socket = new WebSocket(getTrackingSocketUrl());
    } catch (error) {
      onError(error.message || "No se pudo abrir la conexión al mapa.");
      onStatus("error");
      scheduleReconnect();
      return;
    }

    socket.onopen = () => {
      socket.send(JSON.stringify({
        type: "subscribe_admin_drivers",
        subscriptionId: TRACKING_SUBSCRIPTION_ID,
        token,
      }));
    };
    socket.onmessage = (message) => {
      let event;
      try {
        event = JSON.parse(message.data);
      } catch {
        return;
      }

      if (event.subscriptionId && event.subscriptionId !== TRACKING_SUBSCRIPTION_ID) {
        return;
      }

      if (event.type === "error") {
        stopRetrying = true;
        onError(event.payload?.message || "El servidor rechazó la suscripción al mapa de conductores.");
        onStatus("error");
        socket.close();
        return;
      }

      if (event.type === "snapshot" || event.type === "upsert") {
        onStatus("connected");
      }
      onEvent(event);
    };
    socket.onerror = () => socket.close();
    socket.onclose = () => {
      if (disposed || stopRetrying) return;
      onStatus("disconnected");
      scheduleReconnect();
    };
  }

  connect();

  return () => {
    disposed = true;
    window.clearTimeout(reconnectTimer);
    if (socket?.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify({
        type: "unsubscribe",
        subscriptionId: TRACKING_SUBSCRIPTION_ID,
      }));
    }
    socket?.close();
  };
}
